import i18next from 'i18next'

export default {
  install(app) {
    // Make i18next available as $t() and $i18n in all components
    app.config.globalProperties.$t = (key, defaultValue = '') => {
      return i18next.t(key) || defaultValue
    }
    app.config.globalProperties.$i18n = i18next
  },
}
